export { default } from './src/insert-macros';
